/* eslint-disable import/prefer-default-export */
import { UseQueryOptions, useQuery } from "@tanstack/react-query";
import { getUserRoles } from "api/services/user";
import { userQueryKeys } from "./userQueryKeys";

export function useGetUserRoles(options: UseQueryOptions) {
  return useQuery({
    queryKey: userQueryKeys.userRoles,
    queryFn: () => getUserRoles({ params: { page_size: "max" } }).then((res) => res.data),
    ...options,
  });
}
